export default "__VITE_ASSET__D6Dfwc0I__"